import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { getArtGenerationAvailability } from '../../utils/artConsumption'
import styles from './styles.module.css'

export const FreePlanBanner = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [showBanner, setShowBanner] = useState(null)

  const checkBanner = useCallback(async () => {
    try {
      const artAvailability = await getArtGenerationAvailability(1, {
        allowCampaignGeneration: true,
      })

      const total = artAvailability?.total ?? 0
      const available = artAvailability?.available ?? 0
      const isLimitExhausted =
        Number.isFinite(total) && total > 0 && available <= 0

      setShowBanner(isLimitExhausted)
    } catch {
      setShowBanner(false)
    }
  }, [])

  useEffect(() => {
    checkBanner()

    const handlePlanUpdate = () => {
      checkBanner()
    }

    window.addEventListener('user-plan-count-updated', handlePlanUpdate)
    return () => {
      window.removeEventListener('user-plan-count-updated', handlePlanUpdate)
    }
  }, [checkBanner])

  if (showBanner === null || !showBanner) return null

  return (
    <div className={styles.banner}>
      <p className={styles.text}>
        {t('arts_exhausted_banner.text')}{' '}
        <span
          className={styles.upgradeLink}
          onClick={() => navigate('/PlanCheckoutUser')}
        >
          {t('arts_exhausted_banner.plans_link')}
        </span>
      </p>
    </div>
  )
}
